import React from 'react';
import styled from 'styled-components';
import { TextField } from '@material-ui/core';

const Container = styled.div`
  padding: 1.875rem 0;
  border-bottom: 2px solid ${({ theme }) => theme.palette.blue.light};
  height: 100%;
`;

const Header = styled.h2`
  font-size: 1rem;
  line-height: 1.0625;
  font-family: ${({ theme }) => theme.typography.headerFontFamily};
  margin: 0.625rem 0;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
`;

const CustomTextField = styled(TextField)`
  &&& {
    max-width: 47%;
    margin-right: 0.5rem;

    & > div::after,
    & > div::before {
      border-bottom: 2px solid ${({ theme }) => theme.palette.blue.light};
    }

    & > label,
    & > label:focus {
      color: ${({ theme }) => theme.palette.blue.main};
    }

    &:last-child {
      margin-right: 0;
    }
  }
`;

const Quantities = ({ quantities, unit }) => (
  <Container>
    <Header>Quantity</Header>
    <Row>
      <CustomTextField
        disabled
        id="quantities"
        name="quantities"
        label="Quantity"
        value={quantities}
      />
      <CustomTextField
        disabled
        id="unit"
        name="unit"
        label="Unit"
        value={unit}
      />
    </Row>
  </Container>
);

export default Quantities;
